import {BasicObject, SafeAny} from '@/types';
import type {MessageDataPayload} from './type';
import {toAllCasinoGame, toGame} from '../game-navigate';
import {
  goTo,
  toSports,
  envConfig,
  hideTabbar,
  showTabbar,
  getDeviceCode,
  getPushToken,
} from '@utils';
import {forecast, order} from './im-magic';
import {postReport, TReportType, TSourceType} from './im-service';
import {getGameURL} from '@/pages/home/home.service';
import React, {useCallback, useEffect, useRef, useState} from 'react';
import Spin from '@/components/basic/spin';
import theme from '@/style';
import {useWebView} from '../hooks/webview.hooks';
import globalStore from '@/services/global.state';
import {packageId} from '@/config';
import qs from 'qs';
import {imManager} from './im.state';
import {FadeInView} from '@basicComponents/animations';
import {useFocusEffect, useRoute} from '@react-navigation/native';

const gameMap: {
  [key: string]: string;
} = {
  color: 'Color',
  dice: 'Dice',
  '3Digit': 'Digit',
  quick3d: 'Digit',
  scratch: 'Scratch',
  matka: 'GameSatta',
  kerala: 'GameWebView',
  quickStateLottery: 'MixLottery',
  stateLottery: 'MixLottery',
};

enum EventType {
  PLAY = 'play',
  FOLLOWED = 'followed',
  LOGIN = 'login',
  SUCCESS = 'success',
  FAIL = 'fail',
  BACK = 'back',
  USER_EDITOR = 'userEditor',
  START_GAME = 'startGame',
  ROUTE_CHANGED = 'routeChange',
  TABBA_CHANGED = 'tabBar',
  FOCUS_CHANGED = 'focusChanged',
  UNREAD_CHANGED = 'unreadChanged',
  INPUT_FOCUS = 'input_focus', // 主要修复im ios 键盘问题
  // native路由变化
  NATIVE_ROUTE_CHANGE = 'nativeRouteChange',
  FORECAST = 'forecast', // 彩票预测
}

interface IDataFromChat {
  source: string | 'chat-room';
  payload: MessageDataPayload;
}

type IMProps = {
  close?: boolean;
  closeCallback?: () => void;
};
const defaultProps = {
  close: false,
  closeCallback: () => {
    imManager.setVisibleState(false);
  },
};
const IMWebView = (props: IMProps) => {
  const {close = false, closeCallback} = Object.assign(defaultProps, props);
  const [pageLoading, setPageLoading] = React.useState(true);
  const tokenRef = useRef('');
  const [token, setToken] = useState('');
  const [version, setVersion] = useState(0);
  const isFocus = useRef(true);
  const defaultParams = useRoute().params;
  const [params, setParams] = useState(
    defaultParams || imManager.getState().visibleState.parameters || {},
  );
  useEffect(() => {
    const sub = globalStore.tokenSubject.subscribe(token => {
      setToken(token || '');
    });
    imManager.visibleState.subscribe(({isVisible, parameters}) => {
      isFocus.current = isVisible;
      if (isVisible) {
        if (parameters) {
          setParams(parameters);
        }
      }
    });
    tokenRef.current = localStorage.getItem('token') || '';
    return () => {
      sub.unsubscribe();
    };
  }, []);
  const getSportURL = async (gametype: string) => {
    const url = await getGameURL(gametype);
    toSports(gametype.split('_')[0].toUpperCase() + ' Sports', url);
  };

  const playNow = (fromData: SafeAny) => {
    const {gameType, rawData, gameName} = fromData;
    const gameCode = gameMap[gameType];
    localStorage.setItem('PlayNow', `im-${gameCode}`);
    const jumpParams = {} as SafeAny;

    switch (gameType) {
      case 'quick3d':
      case '3Digit': {
        jumpParams.id = rawData?.pickThreeId;
        jumpParams.pickName = gameName;
        jumpParams.pickGameType = gameType === 'quick3d' ? 'quick' : 'normal';
        // jumpParams.cycle = item.cycle;
        break;
      }
      case 'matka': {
        jumpParams.type = 'kerala';
        jumpParams.lotteryName = rawData?.lotteryName;
        break;
      }
      case 'kerala': {
        const rawData2Str = rawData || {};
        jumpParams.id = rawData?.matkaId;
        jumpParams.params = `data=${JSON.stringify(rawData2Str)}`;
        break;
      }
      case 'quickStateLottery':
      case 'stateLottery': {
        jumpParams.lotteryID = rawData?.lotteryID;
        jumpParams.isQuick = gameType === 'quickStateLottery' ? '1' : '0';
        break;
      }
    }
    if (gameType === 'scratch' && window) {
      const curLink = window.location.href.split('?')[0];
      const jumpLink = curLink.replace('webview', 'index/scratch');
      window.location.replace(jumpLink);
    } else if (['quickRace', 'casino', 'live'].includes(gameType)) {
      return toGame({
        source: rawData?.source,
        name: rawData?.gameName,
        gameUrl: rawData?.gameUrl,
        id: rawData?.gameId,
        tripartiteUniqueness: rawData?.tripartiteUniqueness,
      });
    } else if (gameType === 'sport') {
      return getSportURL(
        (rawData?.source || '').toLowerCase().split(' ')[0] + '_sport',
      );
    } else {
      goTo(gameCode, jumpParams);
    }
    return Promise.resolve();
  };

  const handleMessage = (data: string | BasicObject | IDataFromChat) => {
    if (data === 'pageLoading:show') {
      setPageLoading(true);
      return;
    }
    if (data === 'pageLoading:hide') {
      setPageLoading(false);
      return;
    }
    if (typeof data === 'object' && data.source === 'chat-room') {
      localStorage.setItem('from', 'im');
      const {event, data: fromData} = data.payload || {};
      const {gameType, userInviteCode} = fromData || {};
      if (userInviteCode) {
        localStorage.setItem('invitationCode', userInviteCode);
      }
      if (fromData.shareId) {
        localStorage.setItem('shareUserId', fromData.shareId);
      }
      switch (event) {
        case EventType.BACK: {
          if (closeCallback) {
            // closeCallback
            closeCallback();
          }
          break;
        }
        case EventType.LOGIN:
          // const curLink = window.location.href.split('?')[0];
          // const jumpLink = curLink.replace('index/chat', 'login?fromPage=chat');
          // window.location.replace(jumpLink);
          goTo('Login', {fromPage: 'chat'});
          setTimeout(() => {
            imManager.setVisibleState(false);
          }, 200);
          break;
        case EventType.PLAY: {
          playNow(fromData).then(() => {
            imManager.setVisibleState(false);
          });
          break;
        }
        case EventType.FOLLOWED: {
          order(fromData.rawData, gameType)
            .then(() => {
              const user = localStorage.getItem('user') || '{}';
              const userId = JSON.parse(user).userId;
              postReport({
                reportType: TReportType.BETS,
                gameName: fromData?.gameName,
                gameType,
                userId,
                inviteCode: fromData?.userInviteCode,
                gameId: fromData?.gameId,
                issueNo: fromData?.issNo,
                sourceType: TSourceType.IM,
                shareUserId: fromData?.rawData?.userId || fromData?.shareId,
              });
              postMessage &&
                postMessage({
                  source: 'chat-room',
                  payload: {
                    event: EventType.SUCCESS,
                    data: {
                      message: 'success!',
                    },
                  },
                });
            })
            .catch(() => {
              postMessage &&
                postMessage({
                  source: 'chat-room',
                  payload: {
                    event: EventType.FAIL,
                    data: {
                      message: 'failed!',
                    },
                  },
                });
            });
          break;
        }
        case EventType.FORECAST: {
          forecast(fromData, gameType)
            .then(() => {
              postMessage &&
                postMessage({
                  source: 'chat-room',
                  payload: {
                    event: EventType.SUCCESS,
                    data: {
                      message: 'Successful following',
                    },
                  },
                });
            })
            .catch(() => {
              postMessage &&
                postMessage({
                  source: 'chat-room',
                  payload: {
                    event: EventType.FAIL,
                    data: {
                      message: 'failed!',
                    },
                  },
                });
            });
          break;
        }
        case EventType.USER_EDITOR: {
          const curLink = window.location.href.split('?')[0];
          const jumpLink = curLink.replace('index/chat', 'profile');
          window.location.replace(jumpLink);
          setTimeout(() => {
            imManager.setVisibleState(false);
          }, 200);
          break;
        }
        case EventType.START_GAME:
          {
            toAllCasinoGame(fromData?.gameId).then(() => {
              imManager.setVisibleState(false);
            });
          }
          break;
        case EventType.ROUTE_CHANGED:
          if (!isFocus.current) {
            return;
          }
          if (fromData.route.pathname.includes('/home')) {
            showTabbar();
          } else {
            hideTabbar();
          }
          break;
        case EventType.TABBA_CHANGED:
          if (fromData.visible != null) {
            if (fromData.visible) {
              showTabbar();
            } else {
              hideTabbar();
            }
          }
          break;
        case EventType.UNREAD_CHANGED:
          imManager.setUnreadCount(fromData.unRead || 0);
          break;
        case EventType.INPUT_FOCUS:
          if (!fromData.isFocused) {
            document.documentElement.scrollIntoView();
          }
          break;
      }
    }
  };

  const [url, setUrl] = useState('');

  useEffect(() => {
    (async () => {
      const deviceCode = getDeviceCode();
      const getUri = async () => {
        if (params && params.amount && params.customerId) {
          return `chat/${params.customerId}/1`;
        }
        if (params && params.customerId) {
          return `chat/${params.customerId}/1`;
        }
        return 'home';
      };
      const uri = await getUri();
      // if (params && params.customerId) {
      //   delete params.customerId;
      // }
      const qsParams: any = {
        ...params,
        packageId,
        originToken: token,
        isVisitor: !token,
        deviceCode,
        full: close ? 1 : 2,
        t: Date.now(),
      };
      const pushToken = getPushToken();
      if (pushToken) {
        qsParams.pushToken = pushToken;
      }
      const queryString = qs.stringify(qsParams);
      let _url = `${envConfig.IMURL}/#/${uri}?${queryString}`;
      setUrl(_url);
    })();
  }, [token, params, close]);

  const {render, postMessage} = useWebView({
    originUrl: url,
    onMessage: handleMessage,
    onLoadEnd: () => {
      setPageLoading(false);
    },
  });

  useEffect(() => {
    if (token !== tokenRef.current) {
      setVersion(v => v + 1);
      tokenRef.current = token;
    }
  }, [token]);
  useFocusEffect(
    useCallback(() => {
      isFocus.current = true;
      postMessage?.({
        source: 'chat-room',
        payload: {
          event: EventType.FOCUS_CHANGED,
          data: {
            isFocused: true,
          },
        },
      });
      return () => {
        // console.log('postmessagehide');
        showTabbar();
        isFocus.current = false;
        postMessage?.({
          source: 'chat-room',
          payload: {
            event: EventType.FOCUS_CHANGED,
            data: {
              isFocused: false,
            },
          },
        });
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [postMessage]),
  );

  return (
    <div className="w-full h-full" key={version}>
      <FadeInView>
        <Spin loading={pageLoading} style={theme.fill.fill}>
          {render}
        </Spin>
      </FadeInView>
    </div>
  );
};

export default IMWebView;
